export const maintanceRoundCss = `
  .page {
    width: 210mm;
    min-height: 207mm;
    margin: 0;
    background: #fff;
    color: #000;
    padding: 0 2mm;
    font-size: 0.75em;
  }
  header {
    text-align: center;
    padding-top: 5mm;
  }
  header h1 {
    font-size: 32px;
    margin: 200px 0px 20px 0px;
    color: #222;
    font-family: "Verdana";
    font-weight: bold;
  }
  header h2 {
    font-size: 16px;
    font-family: "Verdana";
    margin: 0 0 30px 0;
    color: #222;
  }
  header img {
    max-width: 80%;
    height: 80mm;
    object-fit: contain;
  }
  .margins {
    margin: 0.75em 0;
  }
  h3 {
    font-size: 1.2em;
  }
  h4 {
    font-size: 1.1em;
  }
  .flex {
    display: flex;
    flex-wrap: wrap;
    gap: 1em;
    margin-bottom: 0.2em;
    width: 100%;
  }
  img.review-image {
    width: 175px;
    height: 225px;
    object-fit: contain;
  }
  table {
    border: 1px solid #000;
    color: #000;
    width: 100%;
  }
  tr.header {
    background-color: #f6f8fc;
    font-weight: 600;
  }
  td {
    border: 1px solid #000;
    color: #000;
    padding: 1em;
  }
  pre {
    font-family: inherit;
    white-space: pre-wrap;
    page-break-inside: avoid;
  }
  .print { opacity: 1 !important; height: initial !important; }
  .no-print { display: none; }
`;
